import { connect } from 'react-redux';
import PengaturanTanggalStruktur from '../../views/Settings/PengaturanTanggalStruktur.view';
import {
  getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
  getPrmStaffRombel
} from '../../states/thunks/options.thunk';
import { listBlockUnits, saveDateSettings, getDate} from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getPrmStaffRombelOptions: payload => dispatch(getPrmStaffRombel(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleSaveDateSettings: (payload, goback) => dispatch(saveDateSettings(payload, goback)),
    getDate: (payload, goback) => dispatch(getDate(payload, goback)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PengaturanTanggalStruktur);
